<template>
	<page-link
		class="relative rounded-lg p-2 hover:bg-gray-100"
		:href="'/threads'"
	>
		<span class="sr-only">View notifications</span>
		<ui-icon
			class="flex-shrink-0 h-6 w-6 md:h-5 md:w-5"
			name="message-square"
			stroke-width="2"
		/>
		<span
			class="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-orange-50 transform translate-x-1/4 -translate-y-1/4 bg-orange rounded-full"
			v-if="unreadCount > 0"
			>{{ unreadCount }}</span
		>
	</page-link>
</template>

<script>
export default {
	computed: {
		notifications() {
			let that = this;
			return this.$inertia.page.props.unreadMessages.map(function (m) {
				return {
					from: m.counterpart.company_name,
					text:
						m.type == "BID" ? __("You have received a new offer!") : m.message,
					link: that.$route("threads", { active_id: m.thread_id }),
				};
			});
		},
		unreadCount() {
			return this.notifications.length;
		},
	},
};
</script>
